import { render, staticRenderFns } from "./searchTagBar.vue?vue&type=template&id=092b49c1&scoped=true&lang=html&"
import script from "./searchTagBar.vue?vue&type=script&lang=js&"
export * from "./searchTagBar.vue?vue&type=script&lang=js&"
import style0 from "./searchTagBar.vue?vue&type=style&index=0&id=092b49c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092b49c1",
  null
  
)

export default component.exports